import { Routes, withComponentInputBinding, withHashLocation } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { IdentificationModeComponent } from './features/identification-mode/identification-mode.component';
import { QrErrorComponent } from './features/qr-error/qr-error.component';
import { QrErrorManualComponent } from './features/qr-error-manual/qr-error-manual.component';
import { ScanQrComponent } from './features/scan-qr/scan-qr.component';
import { AppointmentChoiceComponent } from './features/appointment-choice/appointment-choice.component';
import { VisitorIdentificationComponent } from './features/visitor-identification/visitor-identification.component';
import { PersonNotificationComponent } from './features/person-notification/person-notification.component';
import { VisitorWelcomeComponent } from './features/visitor-welcome/visitor-welcome.component';
import { DocumentSelectionComponent } from './features/document-selection/document-selection.component';
import { kioskGuard } from './core/guards/kiosk.guard';
import { checkoutResultGuard } from './core/guards/checkout-result.guard';

// withComponentInputBinding : le paramètre `journey` de la route alimente
// directement l'`input()` du composant, sans souscription manuelle.
export const routerFeatures = [withHashLocation(), withComponentInputBinding()];

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'Constructel — Accueil',
    canActivate: [kioskGuard],
  },
  {
    // Écran de choix du mode, partagé par les deux parcours. Le parcours est
    // dans l'URL (et non dans un service) pour survivre à un rechargement.
    path: 'identification-mode/:journey',
    component: IdentificationModeComponent,
    title: "Constructel — Mode d'identification",
    canActivate: [kioskGuard],
  },
  {
    path: 'scan-qr',
    component: ScanQrComponent,
    title: 'Constructel — Scanner QR code',
    canActivate: [kioskGuard],
    data: { journey: 'checkin' },
  },
  {
    path: 'qr-error',
    component: QrErrorComponent,
    title: 'Constructel — QR code non reconnu',
    canActivate: [kioskGuard],
    data: { journey: 'checkin' },
  },
  {
    path: 'qr-error-manual',
    component: QrErrorManualComponent,
    title: 'Constructel — Identification manuelle',
    canActivate: [kioskGuard],
    data: { journey: 'checkin' },
  },
  {
    path: 'appointment-choice',
    component: AppointmentChoiceComponent,
    title: 'Constructel — Rendez-vous',
    canActivate: [kioskGuard],
    data: { journey: 'checkin' },
  },
  {
    path: 'visitor-identification',
    component: VisitorIdentificationComponent,
    title: 'Constructel — Identification visiteur',
    canActivate: [kioskGuard],
    data: { journey: 'checkin' },
  },
  {
    path: 'person-notification',
    component: PersonNotificationComponent,
    title: 'Constructel — Personne à notifier',
    canActivate: [kioskGuard],
    data: { journey: 'checkin' },
  },
  {
    path: 'visitor-welcome',
    component: VisitorWelcomeComponent,
    title: 'Constructel — Bienvenue',
    canActivate: [kioskGuard],
    data: { journey: 'checkin' },
  },
  {
    // --- Parcours de départ (SPECS §6) -------------------------------------
    path: 'checkout/scan-qr',
    loadComponent: () =>
      import('./features/checkout-scan-qr/checkout-scan-qr.component').then(
        (m) => m.CheckoutScanQrComponent,
      ),
    title: 'Constructel — Scanner QR code de départ',
    canActivate: [kioskGuard],
    data: { journey: 'checkout' },
  },
  {
    // Écrans d'erreur réutilisés : c'est `data.journey` qui change les libellés,
    // la destination du rescan et celle de la bascule manuelle.
    path: 'checkout/qr-error',
    component: QrErrorComponent,
    title: 'Constructel — QR code non reconnu',
    canActivate: [kioskGuard],
    data: { journey: 'checkout' },
  },
  {
    path: 'checkout/qr-error-manual',
    component: QrErrorManualComponent,
    title: 'Constructel — Rechercher ma visite',
    canActivate: [kioskGuard],
    data: { journey: 'checkout' },
  },
  {
    path: 'checkout/search',
    loadComponent: () =>
      import('./features/checkout-search/checkout-search.component').then(
        (m) => m.CheckoutSearchComponent,
      ),
    title: 'Constructel — Signaler mon départ',
    canActivate: [kioskGuard],
    data: { journey: 'checkout' },
  },
  {
    path: 'checkout/confirmation',
    loadComponent: () =>
      import('./features/checkout-confirmation/checkout-confirmation.component').then(
        (m) => m.CheckoutConfirmationComponent,
      ),
    title: 'Constructel — Départ enregistré',
    // Sans résultat en mémoire, l'écran afficherait un nom et une heure vides :
    // accès direct par l'URL ou retour arrière après le retour à l'accueil.
    canActivate: [kioskGuard, checkoutResultGuard],
    data: { journey: 'checkout' },
  },
  {
    path: 'document-selection',
    component: DocumentSelectionComponent,
    title: 'Constructel — Consulter nos documents',
    canActivate: [kioskGuard],
  },
  {
    path: 'documents/:id',
    loadComponent: () =>
      import('./features/document-viewer/document-viewer.component').then(
        (m) => m.DocumentViewerComponent,
      ),
    title: 'Constructel — Document',
    canActivate: [kioskGuard],
  },
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '',
  },
];
